import defineComponent from 'flight';

function MessageBoxUI() {

    this.defaultAttrs({
        closeSelector: '[data-message-box-close-btn]',
        contentSelector: '.message-box-content'
    });

    this.close = function () {
        this.$node.removeClass('message-box-wrapper-active');
    };

    this.showError = function (e, payload) {
        this.select('contentSelector').html(payload.message);

        this.$node.addClass('message-box-wrapper-active');
        this.$node.css({opacity: 1 });
    };

    this.after('initialize', function () {
        this.on(document, 'ui:error:show', this.showError);
        this.on(document, 'data:navigation:after-page-load', this.close);
        this.on('click', { closeSelector: this.close });
    });
}

export default defineComponent.component(MessageBoxUI);


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/ui/message-box-ui.js